/* eslint-disable no-bitwise */
import { Injectable } from '@angular/core';

import { ModalEventBridgeService } from '@frontend/sports/modal/feature';

import { ResultStatus } from '../../../core/picks/pick-models';
import { IEditMyBetState } from '../state';

export enum EditBetPicksResultedState {
    Open = 1 << 0,
    Won = 1 << 1,
    Canceled = 1 << 2,
    Lost = 1 << 3,
}

@Injectable()
export class EditBetUtils {
    constructor(private eventBridgeservice: ModalEventBridgeService) {}

    notifyHideSliderGames(): void {
        this.dispatchSensitivePage('open');
    }

    notifyShowSliderGames(): void {
        this.dispatchSensitivePage('close');
    }

    private dispatchSensitivePage(action: 'open' | 'close'): void {
        const isSensitive = action === 'open' ? 'true' : 'false';

        this.eventBridgeservice.notifySensitivePage({
            isSensitiveForPushNotifications: 'false',
            isSensitiveForSliderGames: isSensitive,
            action,
            id: 'editBet',
            type: 'popup',
        });
    }
}

export function getEditBetResultedState(editBetState: IEditMyBetState): EditBetPicksResultedState {
    const originalPicks = editBetState.originalPicks.map((pickId) => editBetState.picks.pickState[pickId]).filter((pick) => pick !== undefined);

    if (originalPicks.every((pick) => pick.resultedState === ResultStatus.Open)) {
        // Every pick is open.
        return EditBetPicksResultedState.Open;
    }

    if (originalPicks.some((pick) => pick.resultedState === ResultStatus.Lost)) {
        // One pick lost - bet is lost.
        return EditBetPicksResultedState.Lost;
    }

    if (originalPicks.every((pick) => pick.resultedState === ResultStatus.Canceled)) {
        // All picks are cancelled - bet is canceled
        return EditBetPicksResultedState.Canceled;
    }

    if (originalPicks.every((pick) => pick.resultedState === ResultStatus.Won || pick.resultedState === ResultStatus.Canceled)) {
        // All picks are won or canceled (with won picks) result is won.
        return EditBetPicksResultedState.Won;
    }

    // Handle partially open case. Has open + won or cancelled
    let res = EditBetPicksResultedState.Open;
    if (originalPicks.some((p) => p.resultedState === ResultStatus.Won)) {
        res |= EditBetPicksResultedState.Won;
    }
    if (originalPicks.some((p) => p.resultedState === ResultStatus.Canceled)) {
        res |= EditBetPicksResultedState.Canceled;
    }

    return res;
}
